import React, { FC, InputHTMLAttributes } from 'react';
import styled from 'styled-components';
import { textColor, THEME_RED, THEME_SECONDARY, THEME_SILVER, themeColor } from '../../../styles/basics/colors';
import { useTranslation } from 'react-i18next';

interface InputFieldProps {
    error?: boolean;
    bold?: boolean;
}

const StInput = styled.input.attrs({ 'data-displayname': 'LCFormFieldInputText__StInput' })<InputFieldProps>`
    font-style: ${props => (props.value === undefined ? 'italic' : 'normal')};
    border-bottom: 1px solid ${props => (props.error ? themeColor(THEME_RED) : themeColor(THEME_SECONDARY))};
    background-color: ${props => (props.error ? 'rgba(208, 2, 27, 0.1)' : null)};
    box-shadow: none !important;
    padding: unset !important;
    font-weight: ${props => (props.bold ? 'bold' : null)};

    ::placeholder {
        ${textColor(THEME_SILVER)};
    }

    :focus::placeholder {
        color: transparent;
    }
`;

StInput.displayName = 'LCFormFieldInputText__StInput';

type Props = {
    onValueChange?: (e: string) => void;
} & InputHTMLAttributes<Element> &
    InputFieldProps;

export const LCFormFieldInputText: FC<Props> = ({
    onValueChange = () => {},
    error,
    bold,
    type = 'text',
    maxLength = 30,
    ...inputProps
}) => {
    const { t } = useTranslation();
    return (
        <StInput
            placeholder={t('yourLocalContent.yourTitles.none')}
            {...inputProps}
            type={type}
            maxLength={maxLength}
            error={error}
            data-testid="LCFormFieldInputText__StInput"
            onChange={event => onValueChange(event.target.value)}
            bold={bold}
        />
    );
};
